export const FETCH_FEATURE_NEWS_REQUEST = "FETCH_FEATURE_NEWS_REQUEST";
export const FETCH_FEATURE_NEWS_SUCCESS = "FETCH_FEATURE_NEWS_SUCCESS";
export const FETCH_FEATURE_NEWS_FAILURE = "FETCH_FEATURE_NEWS_FAILURE";
